import { render, staticRenderFns } from "./ServeNoticeOfIntentionToProceedOnOtherParty.vue?vue&type=template&id=4ad9d881"
import script from "./ServeNoticeOfIntentionToProceedOnOtherParty.vue?vue&type=script&lang=ts"
export * from "./ServeNoticeOfIntentionToProceedOnOtherParty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports